import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { FormInstance } from 'antd/lib/form';
import useFormCheckErrors from './useFormCheckErrors';

interface Output {
    hasErrors: boolean;
    FormItem: React.ReactNode;
    formReady: boolean;
}

// Use for initial validation to block the submit button if the button is not inside the form
// Return an error boolean value, form ready boolean value, and a React Form item which will perform the checking
export default function useFormHasErrors(
    form: FormInstance,
    initialHasErrors: boolean,
    requiredFields: string[] = []
): Output {
    const { checkErrors, formReady } = useFormCheckErrors(form, requiredFields);

    const [hasErrors, setHasErrors] = useState(initialHasErrors);

    const ErrorChecker = () => {
        useEffect(() => {
            const gotErrors = checkErrors();
            if (gotErrors !== hasErrors) {
                setHasErrors(gotErrors);
            }
        });

        return <></>;
    };

    const FormItem = (
        <Form.Item shouldUpdate style={{ display: 'none' }}>
            {() => <ErrorChecker />}
        </Form.Item>
    );

    return {
        hasErrors,
        FormItem,
        formReady,
    };
}
